import Vue from 'vue'
import VueRouter from 'vue-router'
import TokenService from '../services/storage.service'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

import PropertyListing from '../views/Properties/Listing.vue'
import PropertyNew from '../views/Properties/New.vue'
import PropertyEdit from '../views/Properties/Single.vue'

import Tasks from '../views/Tasks.vue'
import CustomCalendar from '../views/CustomCalendar.vue'
import Settings from '../views/Settings/Settings.vue'

import Users from  '../views/Users.vue'
import User from '../views/User.vue'
import NewUser from '../views/NewUser.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/newuser',
    name: 'New User',
    props: true,
    component: NewUser,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'users/all?page=',
      title: 'All Users',
      key: 'all'
    }
  },
  {
    path: '/user/:id',
    name: 'User',
    component: User,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'users/get',
      title: 'User',
      key: 'user'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/properties',
    name: 'Property Listing',
    component: PropertyListing,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Properties',
      key: 'properties_listing'
    }
  },
  {
    path: '/property/add',
    name: 'New Property',
    component: PropertyNew,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Add Property',
      key: 'properties_add'
    }
  },
  {
    path: '/property/edit/:id',
    name: 'Edit Property',
    component: PropertyEdit,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Edit Property',
      key: 'properties_edit'
    }
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Tasks',
      key: 'tasks_listing'
    }
  },
  {
    path: '/calendar',
    name: 'CustomCalendar',
    props: true,
    component: CustomCalendar,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'calendar/get',
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    props: true,
    component: Settings,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/properties')
  }
  next();
}) 

export default router